/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";

import Box from "../Box";
import Card from "../Card";
import {
  FlexboxProps,
  LayoutProps,
  MarginProps,
  WidthProps,
  PaddingProps,
  BackgroundColorProps,
} from "styled-system";
import { CButton, CText } from "@carrefour/design-system-components-react";
import styled from "styled-components";
import ErrorOrLoadingScreen from "../ErrorOrLoadingScreen";
import { eventTrack } from "../../utils/gtag";
import { InfoBull } from "../InfoBull/InfoBull";

const CardsContainer = styled(Box)`
  gap: ${(props) => `${props?.theme?.space?.[2]}px`};
`;

const Text = styled(CText)`
  font-size: 16px;
`;

type BaseDashboardCardProps = {
  title: string | React.ReactNode;
  subTitle?: string;
  openInformationModal: () => void;
  isUnavailable: boolean;
  isLoading: boolean;
  messageError?: string;
  importedDateTime?: string;
  hasModal: boolean;
  size: "small" | "big";
  children: React.ReactNode;
  option?: React.ReactNode;
} & MarginProps &
  PaddingProps &
  WidthProps &
  LayoutProps &
  FlexboxProps &
  BackgroundColorProps;

const BaseDashboardCard = ({
  title,
  subTitle,
  children,
  option,
  isUnavailable,
  isLoading,
  size,
  messageError,
  hasModal,
  importedDateTime,
  openInformationModal,
  ...rest
}: BaseDashboardCardProps) => {
  useEffect(() => {
    if (isLoading === false && isUnavailable === false) {
      eventTrack({
        eventName: "interaction_metric",
        actionName: "viewed",
        key1: "metric_name",
        value1: title as string,
      });
    }
  }, []);
  return (
    <Card {...rest} overflow={"visible"}>
      <CardsContainer display="flex" alignItems={"center"}>
        <Box
          display="flex"
          justifyContent="space-between"
          width="100%"
        >
          <Box display={"flex"} alignItems={"start"}>
            <Text bold size={"m"} tagStyle={"h4"}>
              {title}
            </Text>
          </Box>
          <Box display={"flex"} flexShrink={0} alignItems={"center"}>
            <InfoBull 
              description={title as string}
              lastUpdated={importedDateTime}
              loading={isLoading}
              isUnavailable={isUnavailable}
              error={!!messageError}
              onOpenTracking={() => {}}
            />
          </Box>
        </Box>
        {hasModal && false && (
          <CButton
            data-testid="open-button"
            onClick={openInformationModal}
            appendIcon={"info-circle"}
            variation={"tertiary"}
            tone={"monochrome"}
          />
        )}
      </CardsContainer>
      {subTitle && (
      <Box display={"flex"} alignItems={"start"}>
        <Text size={"s"} tagStyle={"p"}>
          {subTitle}
        </Text>
      </Box>)}
      
      {option}
      {isUnavailable || isLoading ? (
        <ErrorOrLoadingScreen
          isUnavailable={isUnavailable}
          size={option ? "big" : size}
          messageError={messageError}
        />
      ) : (
        children
      )}
    </Card>
  );
};

export default BaseDashboardCard;
